(ns frontend.view.nev.kyc.process-status-views.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::reminding-signatory-ids
 (fn [db [_]]
   (::reminding-signatory-ids db)))
